// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateTicket-Container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.backarrowMain {
  margin-bottom: 16px;
  cursor: pointer;
}
.CreateTicket-Main-Components {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.TicketTagInputContainer-Main {
  position: relative;
  flex-grow: 1;
  max-width: 200px;
}

.SubjectMain-Input-Container {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  margin-top: 16px;
}

.TicketTagInput-Main-Container {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  position: relative;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  color: #405261;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
}
.TicketTagInput-Main-Container p {
  color: #405261;
  font-size: 12px;
  padding-right: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.TickettagInput {
  border: none;
  outline: none;
  height: 40px;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  width: 75%;
  font-weight: 400;
}

.SubjectMain-Input-Container p {
  display: flex;
  justify-content: center;
  color: #405261;
  padding: 0px 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.TicketMessageInput {
  border: none;
  width: 100%;
  font-family: "Arial", sans-serif;
  height: 46px;
  outline: none;
  resize: none;
  overflow: hidden;
}

.TicketMessageInput ::placeholder {
  color: #93a1b0;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */
}
.SubjectInput {
  border: none;
  outline: none;
  width: 90%;
  height: 40px;
  color: #c5ced6;
  font-size: 12px;
  border-radius: 10%;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.field-label {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
}
.field-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.TicketLine {
  border-bottom: 1px solid #e5e9ec;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  width: 100%;
  height: 1px;
  margin-top: 16px;
}
.TicketButton-Main-Container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.TicketInputButton01 {
  border-radius: 5px;
  background: #148dfd;
  /* position: relative; */
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 24px;
  border: none;
  color: #fff;
  /* display: flex; */
  /* justify-content: center;
  align-items: center;
  gap: 10px; */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  width: "160px";
  height: "40px";
  cursor: pointer;
  line-height: 18px;
  float: right;
}
.TicketInputButton02 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  height: 40px;
  width: 136px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.ticketmessage-footer {
  margin-top: 8px;
}

.PublicMenu-Container {
  position: absolute;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);

  bottom: 110px;
  right: 235px;
  height: "40px";
  width: 184px;
  padding: 8px;
}
.PublicMenu-Main {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0px 4px;
  cursor: pointer;
}
.PublicMenu-Main:hover {
  border-radius: 8px;
  background: #f9fafa;
}
.PublicMenu-Container p {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.submitMenu-Container {
  position: absolute;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 16px;
  bottom: 110px;
  right: 55px;
}
.submitMenu-Container p {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.create-ticket-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 592px;
  box-sizing: border-box;
}

.create-ticket-container.embedded {
  padding: 0;
}

.customer-info-container {
  display: flex;
  gap: 16px;
}

.customer-input {
  flex: 1;
  min-width: 0;
}

.ticket-controls {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.ticket-dropdowns-container {
  display: flex;
}

.SubjectMain-Input-Container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  border: none;
}

.SubjectMain-Input-Container p {
  min-width: 70px;
  margin: 0;
  color: #405261;
  font-size: 14px;
}

.SubjectInput {
  flex: 1;
  border: none;
}

.TicketTagInputContainer-Main {
  flex: 1;
  min-width: 200px;
  max-width: 1200px;
}

/* MUI Overrides */
.MuiOutlinedInput-root {
  height: 40px !important;
}

/* Override MUI hover styles */
.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #d5dce1 !important;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #d5dce1 !important;
  border-width: 1px !important;
}

/* Fix tag input styles */
.MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 4px !important;
}

/* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 0 4px !important;
} */

.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-endAdornment {
  top: calc(50% - 14px);
}

.css-1jbr78v-MuiAutocomplete-root {
  width: 100%;
  margin-bottom: 0px;
}
/* Consistent border color for all inputs */
.MuiOutlinedInput-notchedOutline {
  border-color: #d5dce1 !important;
}

/* Remove the double border from subject input */
.SubjectMain-Input-Container .MuiOutlinedInput-root {
  border: 1px solid #d5dce1;
  border-radius: 4px;
}

.SubjectMain-Input-Container .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

/* Ticket Message Styles */
.Ticket-Message-Container {
  display: flex;
  margin-bottom: 16px;
  gap: 8px;
  align-items: flex-start;
  position: relative;
}

.ticket-user-message {
  flex-direction: row;
}

.ticket-agent-message {
  flex-direction: row-reverse;
}

.ticket-user-avatar,
.ticket-agent-avatar {
  margin-top: 4px;
}

.ticket-message-content-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 336px;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
}

.ticket-agent-message .ticket-message-content-wrapper {
  align-items: flex-end;
}

.ticket-agent-content,
.ticket-user-content {
  border-radius: 8px;
  padding: 10px 16px;
  position: relative;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
}

.ticket-agent-content {
  background-color: #148dfd;
  color: white;
  /* border-top-right-radius: 2px; */
}
.ticket-admin-content,
.ticket-user-content {
  border-radius: 8px;
  padding: 10px 12px;
  position: relative;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
}
.ticket-admin-content {
  background-color: #fff7e6;
  color: black;
}

.ticket-user-content {
  background-color: #f5f7f9;
  color: #405261;
}

.ticket-message-text-container {
  max-width: 100%;
  min-width: 0;
}

.ticket-message-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.ticket-message-text > p {
  margin: 0 0 0.35em;
  white-space: pre-wrap;
}

.ticket-message-text > p:last-child {
  margin-bottom: 0;
}

/* Global * { padding: 0 } removes default list inset; markers sit outside and clip. */
.ticket-message-text :is(ol, ul) {
  display: block;
  margin: 0.25em 0;
  padding-inline-start: 1.5rem;
  list-style-position: outside;
}

.ticket-message-text li {
  display: list-item;
  margin: 0.1em 0;
  white-space: normal;
}

.ticket-message-text li > p {
  margin: 0;
  white-space: pre-wrap;
}

.ticket-message-time {
  margin-top: 4px;
  font-size: 12px;
}

.ticket-agent-time,
.ticket-user-time {
  color: #93a1b0;
  margin: 0;
  font-size: 11px;
}

.ticket-image-container {
  margin-top: 8px;
}

.ticket-message-image {
  max-width: 200px;
  border-radius: 8px;
  cursor: pointer;
}

/* Keep existing classes for backwards compatibility */
/* .Message-Container {
  display: flex;
  margin-bottom: 16px;
  gap: 8px;
  align-items: flex-start;
}

.agent-message {
  flex-direction: row-reverse;
}

.user-message {
  flex-direction: row;
} */
/* 
.Img-Content-Agent {
  background-color: #148DFD;
  color: white;
  border-radius: 8px;
  border-top-right-radius: 2px;
  padding: 10px 12px;
  position: relative;
  max-width: 70%;
  word-wrap: break-word;
}

.Img-Content {
  background-color: #F5F7F9;
  color: #405261;
  border-radius: 8px;
  border-top-left-radius: 2px;
  padding: 10px 12px;
  position: relative;
  max-width: 70%;
  word-wrap: break-word;
} */

/* Styles for attachments */
.ticket-attachments-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.ticket-attachment-item {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}

.ticket-image-container {
  position: relative;
  max-width: 300px;
  border-radius: 8px;
  overflow: hidden;
}

.ticket-message-image {
  max-width: 100%;
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 8px;
}

.ticket-message-image:hover {
  transform: scale(1.03);
}

.ticket-attachment-filename {
  font-size: 12px;
  color: #405261;
  margin-top: 4px;
  word-break: break-word;
}

.ticket-file-container {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f7f9;
  border-radius: 6px;
  margin-top: 4px;
}

.ticket-file-link {
  color: #148dfd;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.ticket-file-link:hover {
  text-decoration: underline;
}

/* Attachment preview styles in input area */
.attachments-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
  background-color: #f5f7f9;
}

.attachment-item {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 4px;
  padding: 4px 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.css-1jbr78v-MuiAutocomplete-root .MuiAutocomplete-tag {
  margin: 0px;
}
.image-preview-container {
  margin-right: 8px;
}

.image-preview {
  max-height: 80px;
  max-width: 80px;
  object-fit: cover;
  border-radius: 4px;
}

.attachment-filename {
  flex: 1;
  font-size: 12px;
  color: #405261;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.remove-attachment-btn {
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* Style status change messages */
.status-change-message {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  width: 100%;
}

.status-change-message .left-line,
.status-change-message .right-line {
  flex: 1;
  height: 1px;
  background-color: #f1f3f5;
}

.status-change-message .message-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 13px;
}

.status-change-message .status-text {
  color: #405261;
  font-size: 12px;
  margin-bottom: 4px;
}

.status-change-message .timestamp {
  color: #93a1b0;
  font-size: 10px;
}

/* Style disabled state for input */
.ChatMessageInput-Main-Container.disabled {
  opacity: 0.8;
  pointer-events: none;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.ChatMessageInput-Main-Container.disabled .TicketMessageInput {
  background-color: #f8f9fa;
  cursor: not-allowed;
  color: #6c757d;
}

.ChatMessageInput-Main-Container.disabled .TicketMessageInput::placeholder {
  color: #6c757d;
  font-style: italic;
}

.ChatMessage-Emoji00 p.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.TicketInputButton01:not(:disabled):hover,
.TicketInputButton01:not(:disabled):focus-visible {
  background-color: #0077cc;

  outline: none;
}
.TicketInputButton02:not(:disabled):hover {
  background-color: #ffffff;
  border-color: #c5ced6;

  outline: none;
}

.TicketInputButton02:disabled {
  cursor: not-allowed;
  background: #f9fafa;
  color: #93a1b0;
  border: 1px solid #c5ced6;
}

.css-3qbkez-MuiSelect-icon {
  position: absolute;
  right: 7px;
  /* top: 0; */
  pointer-events: none;
  color: rgba(0, 0, 0, 0.54);
}
.public-icon-container {
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.group-select-search {
  width: 280px;
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/TicketSectionComponents/CreateTicket/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,iDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB;;cAEY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;;EAEnD,aAAa;EACb,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA,2CAA2C;AAC3C;EACE,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sDAAsD;AACtD;;;;;;;;;;;;;GAaG;AACH;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;;EAErB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".CreateTicket-Container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.backarrowMain {\n  margin-bottom: 16px;\n  cursor: pointer;\n}\n.CreateTicket-Main-Components {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.TicketTagInputContainer-Main {\n  position: relative;\n  flex-grow: 1;\n  max-width: 200px;\n}\n\n.SubjectMain-Input-Container {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  margin-top: 16px;\n}\n\n.TicketTagInput-Main-Container {\n  display: flex;\n  align-items: center;\n  padding: 0px 10px;\n  position: relative;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  color: #405261;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n}\n.TicketTagInput-Main-Container p {\n  color: #405261;\n  font-size: 12px;\n  padding-right: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.TickettagInput {\n  border: none;\n  outline: none;\n  height: 40px;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  width: 75%;\n  font-weight: 400;\n}\n\n.SubjectMain-Input-Container p {\n  display: flex;\n  justify-content: center;\n  color: #405261;\n  padding: 0px 8px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.TicketMessageInput {\n  border: none;\n  width: 100%;\n  font-family: \"Arial\", sans-serif;\n  height: 46px;\n  outline: none;\n  resize: none;\n  overflow: hidden;\n}\n\n.TicketMessageInput ::placeholder {\n  color: #93a1b0;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 112.5% */\n}\n.SubjectInput {\n  border: none;\n  outline: none;\n  width: 90%;\n  height: 40px;\n  color: #c5ced6;\n  font-size: 12px;\n  border-radius: 10%;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.field-label {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 8px;\n}\n.field-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.TicketLine {\n  border-bottom: 1px solid #e5e9ec;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n  width: 100%;\n  height: 1px;\n  margin-top: 16px;\n}\n.TicketButton-Main-Container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.TicketInputButton01 {\n  border-radius: 5px;\n  background: #148dfd;\n  /* position: relative; */\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 24px;\n  border: none;\n  color: #fff;\n  /* display: flex; */\n  /* justify-content: center;\n  align-items: center;\n  gap: 10px; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  width: \"160px\";\n  height: \"40px\";\n  cursor: pointer;\n  line-height: 18px;\n  float: right;\n}\n.TicketInputButton02 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  height: 40px;\n  width: 136px;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.ticketmessage-footer {\n  margin-top: 8px;\n}\n\n.PublicMenu-Container {\n  position: absolute;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n\n  bottom: 110px;\n  right: 235px;\n  height: \"40px\";\n  width: 184px;\n  padding: 8px;\n}\n.PublicMenu-Main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0px 4px;\n  cursor: pointer;\n}\n.PublicMenu-Main:hover {\n  border-radius: 8px;\n  background: #f9fafa;\n}\n.PublicMenu-Container p {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.submitMenu-Container {\n  position: absolute;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 16px;\n  bottom: 110px;\n  right: 55px;\n}\n.submitMenu-Container p {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.create-ticket-container {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  max-width: 592px;\n  box-sizing: border-box;\n}\n\n.create-ticket-container.embedded {\n  padding: 0;\n}\n\n.customer-info-container {\n  display: flex;\n  gap: 16px;\n}\n\n.customer-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.ticket-controls {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.ticket-dropdowns-container {\n  display: flex;\n}\n\n.SubjectMain-Input-Container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n  border: none;\n}\n\n.SubjectMain-Input-Container p {\n  min-width: 70px;\n  margin: 0;\n  color: #405261;\n  font-size: 14px;\n}\n\n.SubjectInput {\n  flex: 1;\n  border: none;\n}\n\n.TicketTagInputContainer-Main {\n  flex: 1;\n  min-width: 200px;\n  max-width: 1200px;\n}\n\n/* MUI Overrides */\n.MuiOutlinedInput-root {\n  height: 40px !important;\n}\n\n/* Override MUI hover styles */\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #d5dce1 !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #d5dce1 !important;\n  border-width: 1px !important;\n}\n\n/* Fix tag input styles */\n.MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 4px !important;\n}\n\n/* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\n  padding: 0 4px !important;\n} */\n\n.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-endAdornment {\n  top: calc(50% - 14px);\n}\n\n.css-1jbr78v-MuiAutocomplete-root {\n  width: 100%;\n  margin-bottom: 0px;\n}\n/* Consistent border color for all inputs */\n.MuiOutlinedInput-notchedOutline {\n  border-color: #d5dce1 !important;\n}\n\n/* Remove the double border from subject input */\n.SubjectMain-Input-Container .MuiOutlinedInput-root {\n  border: 1px solid #d5dce1;\n  border-radius: 4px;\n}\n\n.SubjectMain-Input-Container .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n/* Ticket Message Styles */\n.Ticket-Message-Container {\n  display: flex;\n  margin-bottom: 16px;\n  gap: 8px;\n  align-items: flex-start;\n  position: relative;\n}\n\n.ticket-user-message {\n  flex-direction: row;\n}\n\n.ticket-agent-message {\n  flex-direction: row-reverse;\n}\n\n.ticket-user-avatar,\n.ticket-agent-avatar {\n  margin-top: 4px;\n}\n\n.ticket-message-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  max-width: 336px;\n  min-width: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.ticket-agent-message .ticket-message-content-wrapper {\n  align-items: flex-end;\n}\n\n.ticket-agent-content,\n.ticket-user-content {\n  border-radius: 8px;\n  padding: 10px 16px;\n  position: relative;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  min-width: 0;\n}\n\n.ticket-agent-content {\n  background-color: #148dfd;\n  color: white;\n  /* border-top-right-radius: 2px; */\n}\n.ticket-admin-content,\n.ticket-user-content {\n  border-radius: 8px;\n  padding: 10px 12px;\n  position: relative;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  min-width: 0;\n}\n.ticket-admin-content {\n  background-color: #fff7e6;\n  color: black;\n}\n\n.ticket-user-content {\n  background-color: #f5f7f9;\n  color: #405261;\n}\n\n.ticket-message-text-container {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.ticket-message-text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  max-width: 100%;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.ticket-message-text > p {\n  margin: 0 0 0.35em;\n  white-space: pre-wrap;\n}\n\n.ticket-message-text > p:last-child {\n  margin-bottom: 0;\n}\n\n/* Global * { padding: 0 } removes default list inset; markers sit outside and clip. */\n.ticket-message-text :is(ol, ul) {\n  display: block;\n  margin: 0.25em 0;\n  padding-inline-start: 1.5rem;\n  list-style-position: outside;\n}\n\n.ticket-message-text li {\n  display: list-item;\n  margin: 0.1em 0;\n  white-space: normal;\n}\n\n.ticket-message-text li > p {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.ticket-message-time {\n  margin-top: 4px;\n  font-size: 12px;\n}\n\n.ticket-agent-time,\n.ticket-user-time {\n  color: #93a1b0;\n  margin: 0;\n  font-size: 11px;\n}\n\n.ticket-image-container {\n  margin-top: 8px;\n}\n\n.ticket-message-image {\n  max-width: 200px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* Keep existing classes for backwards compatibility */\n/* .Message-Container {\n  display: flex;\n  margin-bottom: 16px;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.agent-message {\n  flex-direction: row-reverse;\n}\n\n.user-message {\n  flex-direction: row;\n} */\n/* \n.Img-Content-Agent {\n  background-color: #148DFD;\n  color: white;\n  border-radius: 8px;\n  border-top-right-radius: 2px;\n  padding: 10px 12px;\n  position: relative;\n  max-width: 70%;\n  word-wrap: break-word;\n}\n\n.Img-Content {\n  background-color: #F5F7F9;\n  color: #405261;\n  border-radius: 8px;\n  border-top-left-radius: 2px;\n  padding: 10px 12px;\n  position: relative;\n  max-width: 70%;\n  word-wrap: break-word;\n} */\n\n/* Styles for attachments */\n.ticket-attachments-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.ticket-attachment-item {\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.ticket-image-container {\n  position: relative;\n  max-width: 300px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.ticket-message-image {\n  max-width: 100%;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  border-radius: 8px;\n}\n\n.ticket-message-image:hover {\n  transform: scale(1.03);\n}\n\n.ticket-attachment-filename {\n  font-size: 12px;\n  color: #405261;\n  margin-top: 4px;\n  word-break: break-word;\n}\n\n.ticket-file-container {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #f5f7f9;\n  border-radius: 6px;\n  margin-top: 4px;\n}\n\n.ticket-file-link {\n  color: #148dfd;\n  text-decoration: none;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n}\n\n.ticket-file-link:hover {\n  text-decoration: underline;\n}\n\n/* Attachment preview styles in input area */\n.attachments-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  background-color: #f5f7f9;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  background-color: white;\n  border-radius: 4px;\n  padding: 4px 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.css-1jbr78v-MuiAutocomplete-root .MuiAutocomplete-tag {\n  margin: 0px;\n}\n.image-preview-container {\n  margin-right: 8px;\n}\n\n.image-preview {\n  max-height: 80px;\n  max-width: 80px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.attachment-filename {\n  flex: 1;\n  font-size: 12px;\n  color: #405261;\n  margin-right: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 150px;\n}\n\n.remove-attachment-btn {\n  background: #ff4d4f;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n/* Style status change messages */\n.status-change-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 10px 0;\n  width: 100%;\n}\n\n.status-change-message .left-line,\n.status-change-message .right-line {\n  flex: 1;\n  height: 1px;\n  background-color: #f1f3f5;\n}\n\n.status-change-message .message-time {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 13px;\n}\n\n.status-change-message .status-text {\n  color: #405261;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.status-change-message .timestamp {\n  color: #93a1b0;\n  font-size: 10px;\n}\n\n/* Style disabled state for input */\n.ChatMessageInput-Main-Container.disabled {\n  opacity: 0.8;\n  pointer-events: none;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.ChatMessageInput-Main-Container.disabled .TicketMessageInput {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  color: #6c757d;\n}\n\n.ChatMessageInput-Main-Container.disabled .TicketMessageInput::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.ChatMessage-Emoji00 p.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.TicketInputButton01:not(:disabled):hover,\n.TicketInputButton01:not(:disabled):focus-visible {\n  background-color: #0077cc;\n\n  outline: none;\n}\n.TicketInputButton02:not(:disabled):hover {\n  background-color: #ffffff;\n  border-color: #c5ced6;\n\n  outline: none;\n}\n\n.TicketInputButton02:disabled {\n  cursor: not-allowed;\n  background: #f9fafa;\n  color: #93a1b0;\n  border: 1px solid #c5ced6;\n}\n\n.css-3qbkez-MuiSelect-icon {\n  position: absolute;\n  right: 7px;\n  /* top: 0; */\n  pointer-events: none;\n  color: rgba(0, 0, 0, 0.54);\n}\n.public-icon-container {\n  margin-left: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.group-select-search {\n  width: 280px;\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
